import { UseConstant } from "../../libraries/UseConstant"

export const GetUserTypeOptions = () => {
    const { constant } = UseConstant();
    const { USER_TYPES } = constant;

    let rtn_options = [];
    let arrLen = USER_TYPES.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: USER_TYPES[i].key,
                value: USER_TYPES[i].val,
            });
        }
    }

    return rtn_options;
}

export const GetExpertLevelOptions = () => {
    const { constant } = UseConstant();
    const { EXPERT_LEVELS } = constant;

    let rtn_options = [];
    let arrLen = EXPERT_LEVELS.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: EXPERT_LEVELS[i].key,
                value: EXPERT_LEVELS[i].val,
            });
        }
    }

    return rtn_options;
}

export const GetBranchOptions = (branches) => {
    let rtn_options = [];
    let arrLen = branches.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: branches[i].id,
                value: branches[i].branch,
            });
        }
    }

    return rtn_options;
}

export const GetStackOptions = (stacks) => {
    let rtn_options = [];
    let arrLen = stacks.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: stacks[i].stack,
                value: stacks[i].stack,
            });
        }
    }

    return rtn_options;
}

export const getTechnologyOptions = (technologies, stack = undefined) => {
    let rtn_options = [];
    let arrLen = technologies.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            if (stack && technologies[i].stack !== stack) {
                continue;
            }
            rtn_options.push({
                key: technologies[i].id,
                value: technologies[i].technology,
            });
        }
    }

    return rtn_options;
}

export const getUserOptions = (users) => {
    let rtn_options = [];
    let arrLen = users.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: users[i].id,
                value: users[i].name,
            });
        }
    }

    return rtn_options;
}

export const GetDepartmentOptions = (departments) => {
    let rtn_options = [];
    let arrLen = departments.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: departments[i].id,
                value: departments[i].department,
            });
        }
    }

    return rtn_options;
}

export const GetCountryOptions = (countries) => {
    let rtn_options = [];
    let arrLen = countries.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: countries[i].id,
                value: countries[i].country,
            });
        }
    }

    return rtn_options;
}

export const GetCustomerOptions = (customers) => {
    let rtn_options = [{
        key: '',
        value: 'お客様を選んでください'
    }];
    let arrLen = customers.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: customers[i].id,
                value: customers[i].company_name,
            });
        }
    }

    return rtn_options;
}

export const GetContractTypeOptions = () => {
    const { constant } = UseConstant();
    const { CONTRACT_TYPES } = constant;

    let rtn_options = [];
    let arrLen = CONTRACT_TYPES.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: CONTRACT_TYPES[i].key,
                value: CONTRACT_TYPES[i].val,
            });
        }
    }

    return rtn_options;
};

export const GetSexOptions = () => {
    const { constant } = UseConstant();
    const { SEX } = constant;

    let rtn_options = [];
    let arrLen = SEX.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: SEX[i].key,
                value: SEX[i].val,
            });
        }
    }

    return rtn_options;
};

export const GetProjectTypeOptions = () => {
    const { constant } = UseConstant();
    const { PROJECT_TYPES } = constant;

    let rtn_options = [];
    let arrLen = PROJECT_TYPES.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: PROJECT_TYPES[i].key,
                value: PROJECT_TYPES[i].val,
            });
        }
    }

    return rtn_options;
};

export const GetYesNoOptions = () => {
    const { constant } = UseConstant();
    const { YES_NO } = constant;

    let rtn_options = [];
    let arrLen = YES_NO.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                key: YES_NO[i].key,
                value: YES_NO[i].val,
            });
        }
    }

    return rtn_options;
};

export const GetRoleOptions = (roles) => {
    let rtn_options = [];
    let arrLen = roles.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                value: roles[i].id.toString(),
                label: roles[i].role,
            });
        }
    }

    return rtn_options;
}

export const GetResponsibilityOptions = (responsibilities) => {
    let rtn_options = [];
    let arrLen = responsibilities.length;

    if (arrLen > 0) {
        for (let i = 0; i < arrLen; i++) {
            rtn_options.push({
                value: responsibilities[i].id.toString(),
                label: responsibilities[i].responsibility,
            });
        }
    }

    return rtn_options;
}